export enum NATIVE_TOKEN_REQUEST_REASON {
  EXPIRED = 'expired',
  INVALID = 'invalid',
  UNAUTHORIZED = 'unauthorized',
  MISSING = 'missing'
}

export enum ACCESS_TOKEN_REQUEST_EVENT {
  REQUEST_ACCESS_TOKEN = 'REQUEST_ACCESS_TOKEN'
}

export enum APPLY_NATIVE_ACCESS_TOKEN_SOURCE {
  INIT_APP_META_DATA = 'initAppMetaData',
  SYNC_WITH_DEVICES = 'syncWithDevices'
}

export enum NATIVE_TOKEN_REQUEST_OUTCOME {
  TIMEOUT = 'timeout',
  MAX_RETRIES = 'max_retries',
  NETWORK = 'network'
}

export enum WEBVIEW_LOADING_STATUS {
  INITIALIZING = 'initializing',
  LOADING = 'loading',
  READY = 'ready',
  TIMEOUT = 'timeout',
  ERROR = 'error'
}

// Short, path-independent screen token exchanged with the native shells: sent to the
// Mac in the webview_ready payload and accepted by window.fbNavigate. Stable across
// URL/path changes so a route rename never breaks the native handshake.
export enum WEBVIEW_SCREEN {
  TODO = 'todo',
  SETTINGS = 'settings',
  STATS = 'stats',
  ROUTINE_SUGGESTIONS = 'routine-suggestions'
}

// Terminal readiness status the page posts to the native shells once per screen.
export enum WEBVIEW_READY_STATUS {
  READY = 'ready',
  ERROR = 'error'
}

// Machine-readable cause accompanying a WEBVIEW_READY_STATUS.ERROR post.
export enum WEBVIEW_READY_ERROR_REASON {
  NO_TOKEN_TIMEOUT = 'no-token-timeout'
}

// Mac WKWebView message-handler channel the page posts readiness signals to. The Mac
// registers this name via userContentController.add(handler, name:).
export enum MAC_MESSAGE_HANDLER {
  WEBVIEW_READY = 'webview_ready'
}
